<template>
  <div class="notification-image-wrapper">
    <div v-if="teamImageUrl !== undefined" class="notification-circle">
      <img
        v-if="teamImageUrl !== ''"
        :src="teamImageUrl"
        alt="team image"
        data-test="notification-image"
      />
      <span v-else class="initials" data-test="notification-initials">{{ initials }}</span>
    </div>
    <img
      :src="
        props.notification.actionStatus === 'Completed'
          ? require('../../assets/notifications/action-complete.svg')
          : require('../../assets/notifications/action-uncomplete.svg')
      "
      v-if="props.notification.actionStatus"
      class="action-status"
      :alt="props.notification.actionStatus"
      data-test="action-status"
    />
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { csContext } from "../../services/cs-context";
import { NotificationApiModel } from "../../api-models";

const props = defineProps<{ notification: NotificationApiModel }>();

const teamImageUrl = computed(() => {
  if (!props.notification.teamId) {
    return "";
  }
  return csContext.userDocument.teams.find((t) => t.id === props.notification.teamId)?.imageUrl;
});

const initials = computed(() => {
  const { message } = props.notification;
  const match = message.match(/<strong>(.*?)<\/strong>/);
  const textAfterStrong = match ? match[1] : "";
  const words = textAfterStrong.split(" ");
  let firstLetters;
  if (words.length === 1) {
    // eslint-disable-next-line prefer-destructuring
    firstLetters = words[0][0];
  } else {
    const firstAndLastWords = [words[0], words[words.length - 1]];
    firstLetters = firstAndLastWords.map((word) => word[0]).join("");
  }
  return firstLetters;
});

const imageBackgroundColour = computed(() => {
  if (teamImageUrl.value) {
    return "transparent";
  }
  return "#67A6DC";
});
</script>
<style lang="less" scoped>
@import (reference) "../../styles/bootstrap/variables.less";

@width: 60px;
@action-img-width: 20px;

.notification-image-wrapper {
  position: relative;
  width: @width;
  aspect-ratio: 1;
  border-radius: 100vmax;
}

.notification-circle {
  width: @width;
  aspect-ratio: 1;
  border-radius: 100vmax;
  background-color: v-bind(imageBackgroundColour);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #dddddd;

  img {
    width: 100%;
    aspect-ratio: 1;
    object-fit: cover;
    object-position: center;
  }
}

.action-status {
  position: absolute;
  bottom: 0;
  right: 0;
  width: @action-img-width;
  aspect-ratio: 1;
  border-radius: 100vmax;
}

.initials {
  font-weight: bold;
  font-size: 20px;
  color: white;
}
</style>
